import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { IconInformationSvg } from 'apps/sigma2-ui/src/components/svg/IconInformation';

interface ReadinessRatingViewProps {
  setHoverOverReadinessRating: (hoverOverReadinessRating: boolean) => void;
}

export const ReadinessRatingView = (props: ReadinessRatingViewProps) => {
  const language = useLanguage();
  return (
    <div id="readiness-rating" className="p-2">
      <div className="flex justify-center items-center text-sm font-normal">
        <Paragraph textColor="text-gray-800">
          {language.hiringCopilotReadinessRating()}
        </Paragraph>
        <div
          onMouseEnter={() => {
            props.setHoverOverReadinessRating(true);
          }}
          onMouseLeave={() => {
            props.setHoverOverReadinessRating(false);
          }}
        >
          <IconInformationSvg
            svg={{ className: 'h-4 w-4 ml-2 text-gray-800' }}
          />
        </div>
      </div>
    </div>
  );
};
